/**
 * DOSS Search Result Page — Custom JS
 * Companion script untuk custom-search.css
 */
(function () {
  if (!window.location.pathname.includes('/search')) return;

  window.__dossEventMetaByHandle = window.__dossEventMetaByHandle || {};
  window.__dossEventMetaFetchPending = window.__dossEventMetaFetchPending || {};

  var NO_EVENT_META = { isProductEvent: false };

  function parseEventMetaFromQuickViewHtml(html) {
    if (!html || html.indexOf('id="add-to-cart-button"') === -1) {
      return NO_EVENT_META;
    }

    var btnIndex = html.indexOf('id="add-to-cart-button"');
    var chunk = html.slice(Math.max(0, btnIndex - 300), Math.min(html.length, btnIndex + 1200));
    var isProductEvent = /data-is-product-event="true"/.test(chunk);
    var eventDateMatch = chunk.match(/data-event-date="([^"]*)"/);
    var eventTimesMatch = chunk.match(/data-event-times="([^"]*)"/);

    if (!isProductEvent || !eventDateMatch || !eventTimesMatch) {
      return NO_EVENT_META;
    }

    return {
      isProductEvent: true,
      eventDate: eventDateMatch[1],
      eventTimes: eventTimesMatch[1]
    };
  }

  function fetchEventMetaForHandle(handle) {
    if (!handle) return Promise.resolve(null);

    var cached = window.__dossEventMetaByHandle[handle];
    if (cached) {
      return Promise.resolve(cached.isProductEvent ? cached : null);
    }

    if (window.__dossEventMetaFetchPending[handle]) {
      return window.__dossEventMetaFetchPending[handle];
    }

    var promise = fetch('/products/' + handle + '?view=quick-view', {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var meta = parseEventMetaFromQuickViewHtml(html);
        window.__dossEventMetaByHandle[handle] = meta;
        delete window.__dossEventMetaFetchPending[handle];
        return meta.isProductEvent ? meta : null;
      })
      .catch(function () {
        window.__dossEventMetaByHandle[handle] = NO_EVENT_META;
        delete window.__dossEventMetaFetchPending[handle];
        return null;
      });

    window.__dossEventMetaFetchPending[handle] = promise;
    return promise;
  }

  function setSearchButtonLoading(btn) {
    if (!btn || btn.dataset.eventMetaLoading === 'true') return;

    if (!btn.dataset.originalLabel) {
      btn.dataset.originalLabel = btn.textContent.trim();
    }

    btn.dataset.eventMetaLoading = 'true';
    btn.disabled = true;
    btn.classList.add('button--disabled', 'ais-hit--cart-button--loading');
    btn.classList.remove('button--primary', 'event-ended-hidden');
    btn.hidden = false;
    btn.style.removeProperty('display');
    btn.removeAttribute('aria-hidden');
    btn.innerHTML = '<span class="ais-atc-spinner"></span>';
  }

  function clearSearchButtonLoading(btn) {
    if (!btn) return;
    btn.dataset.eventMetaLoading = 'false';
    btn.classList.remove('ais-hit--cart-button--loading');
  }

  function restoreSearchButtonDefault(btn) {
    if (!btn) return;
    clearSearchButtonLoading(btn);
    btn.dataset.eventMetaApplied = 'true';
    btn.disabled = false;
    btn.classList.remove('button--disabled', 'event-ended-hidden');
    btn.classList.add('button--primary');
    btn.hidden = false;
    btn.style.removeProperty('display');
    btn.removeAttribute('aria-hidden');
    btn.textContent = btn.dataset.originalLabel || window.languages.productFormAddToCart || 'Add to cart';
  }

  function applySearchEventButton(btn, meta) {
    clearSearchButtonLoading(btn);
    window.DossEventProductDate.applyToSearchButton(btn, meta);
    btn.dataset.eventMetaApplied = 'true';
  }

  function syncEventProductButtons() {
    if (!window.DossEventProductDate) return;

    var isListView = !!document.querySelector('.ais-hits-container.ais-results-as-list');
    if (!isListView) return;

    document.querySelectorAll('.ais-Hits-item').forEach(function (item) {
      var product = item.querySelector('.ais-hit.ais-product');
      var btn = item.querySelector('.ais-hit--cart-button');
      if (!product || !btn) return;

      var handle = product.getAttribute('data-handle');
      if (!handle) return;

      if (btn.dataset.eventMetaApplied === 'true') return;

      var cached = window.__dossEventMetaByHandle[handle];

      if (cached && cached.isProductEvent) {
        applySearchEventButton(btn, cached);
        return;
      }

      if (cached === NO_EVENT_META) {
        restoreSearchButtonDefault(btn);
        return;
      }

      setSearchButtonLoading(btn);

      fetchEventMetaForHandle(handle).then(function (meta) {
        var currentBtn = item.querySelector('.ais-hit--cart-button');
        if (!currentBtn || currentBtn.dataset.eventMetaApplied === 'true') return;

        if (!meta) {
          restoreSearchButtonDefault(currentBtn);
          return;
        }

        applySearchEventButton(currentBtn, meta);
      });
    });
  }

  /**
   * Parse harga dari text → integer
   * Handles: "$10,099,000.00" dan "Rp 10.099.000"
   */
  function parsePriceText(text) {
    if (!text) return 0;
    var s = text.trim();
    // USD format: hapus decimal cents dulu ("$10,099,000.00" → "$10,099,000")
    if (s.indexOf('$') !== -1) {
      s = s.replace(/\.\d+$/, '');
    }
    return parseInt(s.replace(/[^\d]/g, ''), 10) || 0;
  }

  /**
   * Format angka ke Rupiah: 10099000 → "Rp 10.099.000"
   */
  function formatRupiah(amount) {
    return 'Rp ' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /**
   * Ubah harga dari format Algolia ($X,XXX,XXX.XX) ke Rupiah (Rp X.XXX.XXX)
   */
  function reformatPrices() {
    document.querySelectorAll('.ais-Hits-item').forEach(function (item) {
      var priceEl = item.querySelector('.ais-hit--price > b');
      var strikedEl = item.querySelector('.ais-hit--price-striked');

      if (priceEl) {
        var text = priceEl.textContent.trim();
        if (text && text.indexOf('Rp') === -1 && text.indexOf('$') !== -1) {
          var amount = parsePriceText(text);
          priceEl.textContent = formatRupiah(amount);
        }
      }

      if (strikedEl) {
        var text = strikedEl.textContent.trim();
        if (text && text.indexOf('Rp') === -1 && text.indexOf('$') !== -1) {
          var amount = parsePriceText(text);
          strikedEl.textContent = formatRupiah(amount);
        }
      }
    });
  }

  /**
   * Hitung savings dan tampilkan badge "Save Rp X.XXX.XXX"
   */
  function updateDiscountBadges() {
    document.querySelectorAll('.ais-Hits-item').forEach(function (item) {
      var badge = item.querySelector('.ais-hit--price-discount');
      var priceEl = item.querySelector('.ais-hit--price > b');
      var strikedEl = item.querySelector('.ais-hit--price-striked');

      if (!badge) return;

      if (strikedEl && strikedEl.textContent.trim()) {
        var currentPrice = parsePriceText(priceEl ? priceEl.textContent : '');
        var comparePrice = parsePriceText(strikedEl.textContent);
        var savings = comparePrice - currentPrice;

        if (savings > 0) {
          var newText = 'Save ' + formatRupiah(savings);
          if (badge.textContent !== newText) badge.textContent = newText;
          badge.classList.add('has-discount');
          return;
        }
      }

      if (badge.textContent.trim()) {
        badge.textContent = '';
      }
      badge.classList.remove('has-discount');
    });
  }

  /**
   * Update judul halaman: "Search result" → 'Products for "sony"'
   * Hanya run sekali (URL tidak berubah saat filter/pagination)
   */
  function updateSearchTitle() {
    var titleEl = document.querySelector('.ais-h2');
    if (!titleEl) return;
    // Hanya update kalau masih teks default Algolia
    if (titleEl.dataset.updated) return;
    var urlParams = new URLSearchParams(window.location.search);
    var query = urlParams.get('q') || '';
    if (query) {
      titleEl.textContent = 'Products for "' + query + '"';
      titleEl.dataset.updated = '1';
    }
  }

  /**
   * Reformat stats Algolia:
   * "1 - 20 out of 1,283 results found in 0.006s" → "Showing 1 - 20 of 1.283 results"
   * Ubah label "Sorted by" → "Sort by:"
   */
  function reformatStats() {
    // Reformat stats text
    var statsEl = document.querySelector('.ais-Stats-text');
    if (statsEl) {
      var text = statsEl.textContent.trim();
      var match = text.match(/(\d[\d,]*)\s*-\s*(\d[\d,]*)\s*out\s*of\s*([\d,]+)\s*results/i);
      if (match) {
        var from = match[1];
        var to = match[2];
        var total = match[3].replace(/,/g, '.');
        var newText = 'Showing ' + from + ' - ' + to + ' of ' + total + ' results';
        if (statsEl.textContent !== newText) statsEl.textContent = newText;
      }
    }

    // Ubah label "Sorted by" → "Sort by:"
    var sortEl = document.querySelector('.ais-sort');
    if (sortEl) {
      var textNode = Array.prototype.find.call(sortEl.childNodes, function (n) {
        return n.nodeType === 3 && n.textContent.trim() === 'Sorted by';
      });
      if (textNode) textNode.textContent = 'Sort by: ';
    }
  }

  /**
   * Inject a single reusable quick view modal into the DOM.
   * The theme's _openQuickView handler fetches product data and injects into .modal__inner.
   */
  function injectQuickViewModal() {
    if (document.getElementById('modal-quick-view-search')) return;
    var modal = document.createElement('div');
    modal.id = 'modal-quick-view-search';
    modal.className = 'modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="modal__dialog modal__dialog--stretch" role="dialog">',
        '<button class="modal__close link" data-action="close-modal" title="Close">',
          '<svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">',
            '<path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421362-7.7781745 ',
            '7.7781746 7.7781745 7.7781745-1.4142136 1.4142136-7.7781745-7.7781746-7.7781746 ',
            '7.7781746-1.4142136-1.4142136 7.7781746-7.7781745-7.7781746-7.7781746 ',
            '1.4142136-1.41421362z"/>',
          '</svg>',
        '</button>',
        '<div class="modal__inner"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);
  }

  /**
   * Inject Quick View buttons into each hit's cart section.
   * Only runs when list view is active (.ais-results-as-list).
   * Buttons are removed when switching back to grid view.
   */
  function syncQuickViewButtons() {
    var isListView = !!document.querySelector('.ais-hits-container.ais-results-as-list');

    document.querySelectorAll('.ais-Hits-item').forEach(function (item) {
      var existing = item.querySelector('.ais-quick-view-btn');

      if (!isListView) {
        // Grid view — remove button if present
        if (existing) existing.remove();
        return;
      }

      // List view — inject if not already present
      if (existing) return;

      var product = item.querySelector('.ais-hit.ais-product');
      var handle = product ? product.getAttribute('data-handle') : null;
      if (!handle) return;

      var cartP = item.querySelector('.ais-hit--cart');
      if (!cartP) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ais-quick-view-btn button button--small button--ternary';
      btn.setAttribute('data-product-url', '/products/' + handle);
      btn.textContent = 'Quick view';
      cartP.appendChild(btn);
    });
  }

  /**
   * Reformat PRICE RANGE facet labels.
   * Price text is a raw text node directly inside .ais-RefinementList-label:
   *   <label>"$309,000 – $310,000"<span class="...count">13</span></label>
   */
  function reformatPriceRangeLabels() {
    document.querySelectorAll('.ais-RefinementList-label, .ais-facet--label').forEach(function (label) {
      label.childNodes.forEach(function (node) {
        if (node.nodeType !== 3) return; // text nodes only
        var text = node.textContent;
        if (text.indexOf('$') === -1) return;
        var reformatted = text.replace(/\$[\d,]+(\.\d+)?/g, function (match) {
          return formatRupiah(parsePriceText(match));
        });
        if (reformatted !== text) node.textContent = reformatted;
      });
    });
  }

  /**
   * Inject Rp display boxes below the price slider.
   * Reads aria-valuenow from rheostat handles — never touches input values
   * (Algolia needs raw numbers for filtering).
   * Re-entrant safe: skips if display already present.
   */
  function reformatPriceSliderValues() {
    var container = document.querySelector('.ais-RangeSlider');
    if (!container) return;

    // Already injected — just refresh values
    var existing = container.querySelector('.ais-slider-display');
    if (existing) {
      updateSliderDisplay(container);
      return;
    }

    // Wait until both handles are rendered
    var handles = container.querySelectorAll('.rheostat-handle');
    if (handles.length < 2) return;

    // Build display row: [min box] – [max box]
    var row = document.createElement('div');
    row.className = 'ais-slider-display';

    var minBox = document.createElement('span');
    minBox.className = 'ais-slider-display--min';

    var sep = document.createElement('span');
    sep.className = 'ais-slider-display--sep';
    sep.textContent = '–';

    var maxBox = document.createElement('span');
    maxBox.className = 'ais-slider-display--max';

    row.appendChild(minBox);
    row.appendChild(sep);
    row.appendChild(maxBox);
    container.appendChild(row);

    updateSliderDisplay(container);

    // Watch aria-valuenow on each handle for live updates while dragging
    var sliderObs = new MutationObserver(function () { updateSliderDisplay(container); });
    handles.forEach(function (h) {
      sliderObs.observe(h, { attributes: true, attributeFilter: ['aria-valuenow'] });
    });
  }

  function updateSliderDisplay(container) {
    var minBox = container.querySelector('.ais-slider-display--min');
    var maxBox = container.querySelector('.ais-slider-display--max');
    if (!minBox || !maxBox) return;

    var handles = container.querySelectorAll('.rheostat-handle');
    if (handles.length < 2) return;

    var minVal = parseInt(handles[0].getAttribute('aria-valuenow'), 10) || 0;
    var maxVal = parseInt(handles[1].getAttribute('aria-valuenow'), 10) || 0;

    minBox.textContent = formatRupiah(minVal);
    maxBox.textContent = formatRupiah(maxVal);
  }

  function removeSearchLoader() {
    var loader = document.getElementById('ais-search-loader');
    if (!loader) return;
    loader.classList.add('is-hidden');
    setTimeout(function () { loader.remove(); }, 350);
  }

  /**
   * Watch #algolia-shopify-instantsearch for class change:
   * "ais-results-size-preload" → "ais-results-size-lg"
   * Remove loader as soon as Algolia signals results are ready.
   */
  function watchAlgoliaReady() {
    var el = document.getElementById('algolia-shopify-instantsearch');
    if (!el) {
      // Element not yet in DOM — wait for it
      var bodyObs = new MutationObserver(function () {
        var found = document.getElementById('algolia-shopify-instantsearch');
        if (found) { bodyObs.disconnect(); attachClassObserver(found); }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      return;
    }
    attachClassObserver(el);
  }

  function attachClassObserver(el) {
    // Already ready (e.g. bfcache restore)
    if (!el.classList.contains('ais-results-size-preload')) {
      removeSearchLoader();
      return;
    }
    var obs = new MutationObserver(function () {
      if (!el.classList.contains('ais-results-size-preload')) {
        obs.disconnect();
        removeSearchLoader();
      }
    });
    obs.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function run() {
    reformatPrices();
    updateDiscountBadges();
    updateSearchTitle();
    reformatStats();
    reformatPriceRangeLabels();
    reformatPriceSliderValues();
    injectQuickViewModal();
    syncQuickViewButtons();
    syncEventProductButtons();

    // Loader removal is handled by watchAlgoliaReady() via class change observer
  }

  /**
   * AJAX Add to Cart for Algolia list view.
   * Intercepts .ais-hit--cart-button clicks, POSTs to /cart/add.js,
   * then dispatches product:added so the theme's cart drawer opens.
   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ais-hit--cart-button');
    if (!btn) return;

    if (
      btn.hidden
      || btn.classList.contains('event-ended-hidden')
      || btn.classList.contains('ais-hit--cart-button--loading')
      || btn.disabled
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    // Algolia uses data-form-id pointing to a separate form element (not a parent)
    var formId = btn.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var quantityInput = form.querySelector('input[name="quantity"]');
    if (!variantInput) return;

    var variantId = variantInput.value;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    // Loading state
    var originalText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="ais-atc-spinner"></span>';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        btn.disabled = false;
        btn.innerHTML = originalText;
        if (res.ok) {
          // Wait for Shopify to finish updating cart session before re-rendering
          setTimeout(function () {
            // Dispatch on document.body so it bubbles UP to document.documentElement
            // where the theme's Cart delegateRoot listener lives
            document.body.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: { quantity: quantity, button: btn }
            }));
          }, 500);
        } else {
          res.json().then(function (data) {
            alert(data.description || 'Failed to add to cart.');
          });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = originalText;
      });
  }, true); // capturing phase — fires before Algolia's own click handler

  // Run on every Algolia DOM update
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 150);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also listen for view toggle clicks — MutationObserver fires before
  // .ais-results-as-list class is added, so we need a separate delayed call
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.ais-change-display span');
    if (toggle) {
      setTimeout(function () {
        syncQuickViewButtons();
        syncEventProductButtons();
      }, 300);
    }
  });

  /**
   * Recursively search through <template> elements, mirroring theme's Dom.deepQuerySelector.
   * Needed because the product quick-view content lives inside a <template> tag.
   */
  function deepQuerySelector(root, selector) {
    var el = root.querySelector(selector);
    if (el) return el;
    var templates = root.querySelectorAll('template');
    for (var i = 0; i < templates.length; i++) {
      el = deepQuerySelector(templates[i].content, selector);
      if (el) return el;
    }
    return null;
  }

  /**
   * Close our quick view modal and restore page scroll.
   */
  function closeQuickViewModal() {
    var modal = document.getElementById('modal-quick-view-search');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-locked');
    // Fire modal:closed so ProductSection cleanup listener can run
    modal.dispatchEvent(new CustomEvent('modal:closed'));
    // Clear inner after transition so it doesn't flash on next open
    var inner = modal.querySelector('.modal__inner');
    if (inner) {
      setTimeout(function () { inner.innerHTML = ''; }, 300);
    }
  }

  // Quick view OPEN — capturing phase, fires before any parent bubbling handlers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ais-quick-view-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var productHandle = btn.getAttribute('data-product-url'); // e.g. /products/handle
    var modal = document.getElementById('modal-quick-view-search');
    if (!modal || !productHandle) return;

    // Append ?view=quick-view to get the no-layout quick-view template
    var fetchUrl = productHandle + '?view=quick-view';

    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');

    modal.classList.add('is-loading');
    var inner = modal.querySelector('.modal__inner');
    if (inner) inner.innerHTML = '';

    fetch(fetchUrl, { credentials: 'same-origin', method: 'GET' })
      .then(function (response) { return response.text(); })
      .then(function (content) {
        var fragment = document.createRange().createContextualFragment(content);
        // The quick-view section is wrapped in a <template> tag; use deepQuerySelector
        var modalContent = deepQuerySelector(fragment, '[data-section-type="product-quick-view"]');
        if (inner && modalContent) {
          inner.appendChild(modalContent);
          // Boot the product section JS (variant picker, AJAX ATC, gallery, etc.)
          // mirrors what the theme's own _openQuickView does after fetching
          if (window.ProductSection) {
            var ps = new window.ProductSection(modalContent);
            // Clean up section JS when modal closes to prevent memory leaks
            modal.addEventListener('modal:closed', function cleanup() {
              if (ps && ps.onUnload) ps.onUnload();
              modal.removeEventListener('modal:closed', cleanup);
            });
          }

          if (window.DossEventProductDate && window.DossEventProductDate.scheduleApplyToScope) {
            window.DossEventProductDate.scheduleApplyToScope(modalContent);
          }
        }
        modal.classList.remove('is-loading');
      })
      .catch(function () {
        modal.classList.remove('is-loading');
      });
  }, true); // capturing phase — fires before any bubbling parent handlers

  // Quick view CLOSE — handle close button, overlay click, and Escape key.
  // ModalManager can't close our modal because we opened it manually (bypassing its queue).
  document.addEventListener('click', function (e) {
    var modal = document.getElementById('modal-quick-view-search');
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

    // Close button click
    if (e.target.closest('#modal-quick-view-search [data-action="close-modal"]')) {
      closeQuickViewModal();
      return;
    }

    // Click on backdrop (the modal element itself, outside the dialog)
    if (e.target === modal) {
      closeQuickViewModal();
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('modal-quick-view-search');
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        closeQuickViewModal();
      }
    }
  });

  // Watch Algolia class change to remove loader at the right time
  watchAlgoliaReady();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
